module.exports = __webpack_public_path__ + "img/from_speak_info_1_4x.e6dd7b1a.png";